import { useState } from 'react'
import DOMPurify from 'dompurify';
import './Contact.css'

import SEO from '../../Components/SEO/SEO';
import PageTitle from '../../Hooks/PageTitle';

const getRandomPhrase = () => {
	const phrases = ['Disturb My Peace','Summon Me','Break Domain Expansion','Release the Pigeon'];
	return phrases[Math.floor(Math.random() * phrases.length)];
};

// const server_url = "http://localhost:8080"
const server_url = "https://portfolio-server-three-xi.vercel.app/"
const random_phrase = getRandomPhrase();

const Contact = ({ ShowMessage }) => {
    PageTitle('Contact Me');

	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [message, setMessage] = useState('');
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [isCooldown, setIsCooldown] = useState(false);


	const HandleSend = async () => {
		if (!name || !email || !message) {ShowMessage('All fields are required!', 'warning'); return;}
		if (!emailRegex.test(email)) {ShowMessage('Please enter a valid email address!', 'warning'); return;}
		setIsSubmitting(true);

		const clean_name = DOMPurify.sanitize(name);
    	const clean_email = DOMPurify.sanitize(email);
    	const clean_message = DOMPurify.sanitize(message);

		try {
			const response = await fetch(server_url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ name: clean_name, email: clean_email, message: clean_message }),
			});
			const data = await response.json();
			if (data.success) {ShowMessage('Message sent successfully!', 'succeed');
			} else {ShowMessage('There was an error processing your message, please try again.', 'failed');}
		} catch (error) {ShowMessage('There was a server error, please try again.', 'failed');
		} finally {
			setIsSubmitting(false);
			setIsCooldown(true);
			setTimeout(() => setIsCooldown(false), 3000);
		}
  	};
  
	return (
		<>
			<SEO 
				title="Contact Me"
				description="Get in touch with Yassine Bazgour for collaborations, hiring, project discussions, or AI and full-stack development inquiries. Open to research, engineering, and innovative tech ideas."
				url="https://yassinebazgour.vercel.app/Contact"
				keywords="Contact Yassine Bazgour, hire AI engineer, AI collaboration, full stack developer contact, data science projects, machine learning engineer Morocco, AI student Marrakech, tech collaboration"
			/>
			<section className='contact-section'>
				<span className='contact-title'>
					{random_phrase}
				</span>
				<span className='contact-description'>
					Hiring me? Got a question? Have a testemonial? Need a collaborator? Or just want to share a cat video (no judgment).<br/>
					Drop a message, I'm all ears (and maybe some wires, too). Let's connect! 🚀😊
				</span>
				<div className='contact-container'>
					<div className='inputs-container'>
						<div className='input-container'>
							<span className='input-label'>Full name</span>
							<input 
								className='contact-input' 
								type='text' 
								placeholder='Enter your full name'
								value={name}
								onChange={(e) => setName(e.target.value)}
							></input>
						</div>
						<div className='input-container'>
							<span className='input-label'>Email Address</span>
							<input 
								className='contact-input' 
								type='email' 
								placeholder='Enter your email address'
								value={email}
								onChange={(e) => setEmail(e.target.value)}
							/>
						</div>
					</div>
					<div className='contact-content-container'>
						<span className='input-label'>Message</span>
						<textarea 
							className='contact-content' 
							placeholder="Drop your message, and let's stay connected!"
							value={message}
							onChange={(e) => {
								const capitalizedMessage = 
								e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
								setMessage(capitalizedMessage);
							}}
						/>
					</div>
					<button
						onClick={HandleSend} 
						className='send-button'
						disabled={isSubmitting || isCooldown}
					>
						<i className="fas fa-paper-plane"></i>
						{isSubmitting ? 'Sending...' : 'Send'}
					</button>
				</div>
			</section>
		</>	
	)
}

export default Contact
